module.exports = __webpack_public_path__ + "static/media/gm.39937d8f.svg";